/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import _ from "underscore";
import eventEmitterMixin from "web/script/mixins/event-emitter";

export default _.extend({}, eventEmitterMixin);

